import { createSpeechmaticsJWT } from "@speechmatics/auth";
import { SPEECHMATICS_DEFAULT_API_URL } from "../hooks/useOkhatiAiSettings";

export function formatTranscriptionError(err: unknown): string {
  if (!(err instanceof Error)) {
    return "Failed to start voice transcription";
  }

  const { message } = err;

  if (message === "Failed to fetch" || message.includes("NetworkError")) {
    return "Could not connect to Speechmatics. Check your internet connection and Speechmatics API key in Resource Centre → Settings → Okhati AI.";
  }

  if (message.includes("Transcription API key is not configured")) {
    return "Speechmatics API key is not configured. A Super Admin must add it in Resource Centre → Settings → Okhati AI.";
  }

  if (message.includes("Transcription API URL is not configured")) {
    return "Speechmatics API key is not configured. A Super Admin must add it in Resource Centre → Settings → Okhati AI.";
  }

  if (message.includes("401") || message.includes("403") || message.includes("Unauthorized")) {
    return "Invalid transcription API key. Check the key in Resource Centre → Settings → Okhati AI.";
  }

  return message;
}

interface SpeechmaticsTokenOptions {
  apiKey: string;
  apiUrl?: string;
}

export default async function getSpeechmaticsRealtimeToken({
  apiKey,
  apiUrl
}: SpeechmaticsTokenOptions): Promise<string> {
  try {
    const managementPlatformURL = (apiUrl || SPEECHMATICS_DEFAULT_API_URL).replace(/\/$/, "");

    return await createSpeechmaticsJWT({
      type: "rt",
      apiKey,
      ttl: 60,
      managementPlatformURL
    });
  } catch (err) {
    throw new Error(formatTranscriptionError(err));
  }
}
